import React from "react";
import TrackVisibility from "react-on-screen";
import Pagetitle from "../elements/Pagetitle";
import Skill from "../elements/Skill";

const aboutContent = {
  name: "Yuri Baptista",
  avatarImage: "/images/yurita-avatar.jpg",
  content:
    "Estudiante de Front-End desde 2020",
};

const progressData = [
  {
    id: 1,
    title: "HTML",
    percantage: 40,
    progressColor: "#D69DAE",
  },
  {
    id: 2,
    title: "CSS",
    percantage: 30,
    progressColor: "#D69DAE",
  },
  {
    id: 3,
    title: "JS",
    percantage: 30,
    progressColor: "#D69DAE",
  },

  {
    id: 4,
    title: "React JS",
    percantage: 40,
    progressColor: "#D69DAE",
  },


];



function AboutDev() {
  return (
    <section id="about">
      <div className="container">
        <Pagetitle title="Yurita Front-End" />
        <div className="row">
          <div className="col-md-3">
            <div className="text-center text-md-left">
              <img src={aboutContent.avatarImage} alt={aboutContent.name} />
            </div>
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
          </div>

          <div className="col-md-9 triangle-left-md triangle-top-sm">
            <div className="rounded bg-white shadow-dark padding-30">
              <div className="row">
                <div className="col-md-6">
                  <p>{aboutContent.content}</p>
                  <div className="mt-3">
                    
                  </div>
                  <div
                    className="spacer d-md-none d-lg-none"
                    data-height="30"
                  ></div>
                </div>

                
                <div className="col-md-6">
                  {progressData.map((progress) => (
                    <TrackVisibility
                      once
                      key={progress.id}
                      className="progress-wrapper"
                    >
                      <Skill progress={progress} />
                    </TrackVisibility>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="spacer" data-height="70"></div>
    
      </div>

    </section>


  );
}

export default AboutDev;
